import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import API from "../../../services/axiosInstance";
import InstreamAdSetting from "../Instream-Ad-Settings/InstreamSetting";
import { FormLoader, useFormLoader } from "../../common_modules/loader";

const UpdateInstreamSetting = () => {
    const url = useParams();
    // const settingApiId = useLocation().state;
    
    const id = url?.guid
    const adId = url?.adId
    
    const splitSize = (size) => {
        if (!size) return {};
        const [w, h] = size.split("*");
        return { width: w, height: h };
    };
    const [instreamMeta, setInstreamMeta] = useState({
        id: null,
        guid: null,
    });
    const [defaultValues, setDefaultValues] = useState([]);
     // custom hook loader
    const { isLoading, startLoading, stopLoading } = useFormLoader();

    const fetchFormData = async () => {
        try {
            startLoading();
            const formDataRes = await API.get(`publisher/instream/setting/${adId}`);
            const d = formDataRes?.data?.data;
            setInstreamMeta({
                id: d.id,
                guid: d.guid,
            })
            setDefaultValues({
                status: 1,
                label: d.instreamLabel,
                accId: d.accId,
                accGuid: d.accGuid,
                // contentManag: d.contentId
                //     ? { value: d.contentId, label: d.contentId }
                //     : null,
                contentManag: {
                    value: d.contentId,
                },

                mobileSize: d.mobilePlayerSizes
                    ? { value: d.mobilePlayerSizes, label: d.mobilePlayerSizes }
                    : null,
                custom_mob_width: splitSize(d.customMobilePlayerSizes).width,
                custom_mob_height: splitSize(d.customMobilePlayerSizes).height,
                desktopSize: d.desktopPlayerSizes
                    ? { value: d.desktopPlayerSizes, label: d.desktopPlayerSizes }
                    : null,
                custom_desk_width: splitSize(d.customDesktopPlayerSizes).width,
                custom_Desk_Height: splitSize(d.customDesktopPlayerSizes).height,

                header_biding: d.headerBiding,
                init_ad_req: d.initialAdrequest,
                autoPlay: d.autoplay,
                view_port_init_req: d.viewportInitialRequest ? d.viewportInitialRequest : "",
                out_of_view: d.outOfView,
                in_view: d.inView,

                video_controls: d.videoControls,
                video_controls_enable: d.videoControlsEnable,
                ad_controls: d.adControls,

                powered_by_link: d.poweredByLink,
                powered_by_text: d.poweredByText,
                powered_by_img: d.poweredByImg,

                is_detachable: d.isDetachable,
                bottom_px: d.bottomPx,
                viewport_init_req_detach: d.detachViewport,
                detach_close_action: d.detachCloseAction === '' ? '1' : d.detachCloseAction,

                detach_mobile_width: splitSize(d.detachMobileSize).width,
                detach_mobile_height: splitSize(d.detachMobileSize).height,

                detach_desktop_width: splitSize(d.detachDesktopSize).width,
                detach_desktop_height: splitSize(d.detachDesktopSize).height,

                wrapper_style: d.wrapperStyle,

                is_retry: d.isRetry,
                retry_interval: d.retryInterval,
                max_retry_count: d.maxRetryCount,
                max_ad_display_count: d.maxAdDisplayCount,

                is_content_replay: d.isContentReplay,
                content_replay_count: d.contentReplayCount,

                is_companion_ad: d.isCompanionAd,
                is_companion_ad_unit: d.companionAdUnit,

                via_Gam: d.viaGam,
                documentViewability: d.documentViewability,
                remarks: d.remarks,
                // ads: d.settingOptions?.map((ad) => ({
                //     selectAd: {
                //     value: ad.adId,
                //     // label: `Ad ${ad.adId}`,
                //     },
                //     adType: ad.adType,
                //     adTime: ad.adTime,
                //     id:ad.id || 0,
                //     instreamSetupId:ad.instreamSetupId,
                //     // id:ad.id,
                // })),
                settingOptions: d.settingOptions || [],
            });
        } catch (error) { console.error("API Error:", error); } 
        finally {
            stopLoading();
        }
    };

    useEffect(() => {
        fetchFormData();
    }, [id]);

    if (!defaultValues) return <p>Loading...</p>
    return (
        <FormLoader isLoading={isLoading} text={"Loading..."}>
        <InstreamAdSetting mode="edit"
            defaultValues={defaultValues}
            instreamMeta={instreamMeta}
        />
        </FormLoader>
    )
}

export default UpdateInstreamSetting;